import { Component, OnInit } from '@angular/core';

import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

    get account() {
        return this.accountService.getCurrentAccount();
    }

    constructor(private accountService: AccountService,
                private authService: AuthService) { }

    ngOnInit() {
    }

    logout() {
        this.authService.logout();
    }
}
